<template>
  <div class="searchBtnBox">
    <div class="flex1">
      <el-input 
        class="searchBtn" 
        :placeholder="placeholder"
        v-model.trim="value" 
        @keyup.enter.native="search()">
        <i slot="suffix" class="el-icon-search" @click="search()" ></i>
      </el-input>
      <span class="searchTotal" v-if="total">共{{total}}条数据</span>
    </div>
  </div>
</template>

<script>
export default {
  props:['placeholder','total'],
  created() {},
  data() {
    return {
      value: '',
    };
  },
  watch: {
    value(){
      this.$emit("update:value", this.value);
    }
  },
  methods: {
    search() {
      this.$emit("search");
    },
  },
};
</script>

<style scoped lang="scss">
.searchBtnBox{
  display: flex;
  flex: 1;
  .flex1{
    .searchBtn {
      line-height: 48px;
      /deep/ .el-input__inner{
        height:50px;
        padding-right: 50px;
      }
      .el-icon-search{
        margin-right: 10px;
        font-size: 22px;
        line-height: 50px;
        cursor: pointer;
      }
    }
    .searchTotal{
      margin-left: 34px;
      color: #666666;
      font-size: 14px;
    }
  }
}
</style>
